
import store from '@/store';
import {
  computed, defineComponent,
} from '@vue/composition-api';

export default defineComponent({
  setup() {
    const network = computed(() => store.state.network);

    const numericVariables = computed(() => Object.entries(store.state.columnTypes || {})
      .filter(([, value]) => value === 'number')
      .map(([key]) => key)
      .filter((key) => {
        if (network.value !== null) {
          return network.value.nodes[0][key] !== undefined;
        }
        return true;
      })
      .sort());
    const categoricalVariables = computed(() => Object.entries(store.state.columnTypes || {})
      .filter(([, value]) => value !== 'number' && value !== 'label')
      .map(([key]) => key)
      .filter((key) => {
        if (network.value !== null) {
          return network.value.nodes[0][key] !== undefined;
        }
        return true;
      })
      .sort());

    const selectedNodes = computed(() => store.state.selectedNodes);
    function clearSelection() {
      store.commit.setSelected(new Set());
    }
    function pinSelectedNodes() {
      if (network.value !== null) {
        network.value.nodes
          .filter((node) => selectedNodes.value.has(node._id))
          .forEach((node) => {
            // eslint-disable-next-line no-param-reassign
            node.fx = node.x;
            // eslint-disable-next-line no-param-reassign
            node.fy = node.y;
          });
      }
    }
    function unPinSelectedNodes() {
      if (network.value !== null) {
        network.value.nodes
          .filter((node) => selectedNodes.value.has(node._id))
          .forEach((node) => {
            // eslint-disable-next-line no-param-reassign
            delete node.fx;
            // eslint-disable-next-line no-param-reassign
            delete node.fy;
          });
      }
    }

    const rightClickMenu = computed(() => store.state.rightClickMenu);
    function changeLayout(varName: string, axis: 'x' | 'y') {
      // Close the menu
      store.commit.updateRightClickMenu({
        show: false,
        top: rightClickMenu.value.top,
        left: rightClickMenu.value.left,
      });

      store.commit.applyVariableLayout({
        varName, axis,
      });
    }

    return {
      rightClickMenu,
      numericVariables,
      categoricalVariables,
      clearSelection,
      pinSelectedNodes,
      unPinSelectedNodes,
      changeLayout,
    };
  },
});
